<template>
  <section
    class="my-8 md:mb-8 mx-auto bg-black pt-6 px-2 md:px-10 pb-0 font-helvetica text-[22px] text-[#999999] shadow-black shadow-xl divide-y-2 divide-white max-w-[1400px]"
  >
    <RallyLogoDownload />
    <div class="pt-8 mt-8">
      <h1 class="text-white text-2xl md:text-3xl font-russo">
        TIME SPEED DISTANCE &#8211; REGULARITY RALLY ROADBOOKS
      </h1>
      <h2 class="font-semibold">
        Car Club - Road Rally - Historic - Classic Car
      </h2>
      <h2 class="font-semibold">Rally Events</h2>
      <GuideDownloadCta />
      <EventsBanner :images="eventsBannerImages" />
    </div>
    <div class="py-8 flex flex-col gap-4">
      <YouTubeEmbed
        style="border: 4px solid #999999"
        class="m-auto w-[300px] h-[182px] md:w-[650px] md:h-[395px] lg:w-[896px] lg:h-[448px]"
        title="Rally Navigator Time Speed Distance Roadbooks - How It Works"
        src="https://www.youtube.com/embed/zEvr7_Jihuo"
        thumb="https://i.ytimg.com/vi/zEvr7_Jihuo/maxresdefault.jpg"
      />
      <h2 class="font-semibold">Beautiful Accurate TSD Rally Roadbooks</h2>
      <h2 class="font-semibold">Time Control Worksheets</h2>
      <h2 class="font-semibold">Excel Worksheet for Timing and Scoring</h2>
      <h2 class="font-semibold">
        GPX Route File - Ready to Load in GPS Software
      </h2>
    </div>
    <div class="py-8 flex flex-col gap-4">
      <h2 class="text-white font-russo text-[28px]">
        ADD TSD FUNCTION TO CROSS COUNTRY OR ROAD RALLY ROADBOOKS
      </h2>
      <router-link
        to="how-to-create-a-cross-country"
        class="flex flex-col gap-2"
      >
        <h2 class="text-[#FF0000] font-black hover:underline">
          Cross Country Format
        </h2>
      </router-link>
      <picture class="contents">
        <source srcset="/images/download/TSD-CC-q9r65dskcjlulkbvf0smss8qxohyeu0iw4e7rowidu.webp" type="image/webp" />
        <img
        decoding="async"
        width="450"
        height="117"
        src="/images/download/TSD-CC-q9r65dskcjlulkbvf0smss8qxohyeu0iw4e7rowidu.png"
        class="flex m-auto"
        alt="Adding Time Speed Distance function to a cross-country roadbook in Rally Navigator"
        />
      </picture>
      <router-link to="how-to-create-a-road-rally" class="flex flex-col gap-2">
        <h2 class="text-[#FF0000] font-black hover:underline">
          Road Rally Format
        </h2>
      </router-link>
      <picture class="contents">
        <source srcset="/images/download/TSD-RR-q9r65dskcjly2sa01ydcne4ulmu2j190xm4nbam20s.webp" type="image/webp" />
        <img
        decoding="async"
        loading="lazy"
        width="450"
        height="134"
        src="/images/download/TSD-RR-q9r65dskcjly2sa01ydcne4ulmu2j190xm4nbam20s.png"
        class="flex m-auto"
        alt="Adding Time Speed Distance function to a road rally roadbook in Rally Navigator"
        />
      </picture>
    </div>
    <div class="py-8 flex flex-col gap-4">
      <picture class="contents">
        <source srcset="/images/time-speed-distance/TSD-RR-Screen-Shot-1.webp" type="image/webp" />
        <img
          decoding="async"
          fetchpriority="high"
          width="1920"
          height="1080"
          src="/images/time-speed-distance/TSD-RR-Screen-Shot-1.png"
          class="flex m-auto"
          alt="Time Speed Distance rally roadbook with target times in Rally Navigator"
        />
      </picture>
    </div>
    <div class="py-8 flex flex-col gap-4 font-arial text-[17px] font-semibold">
      <h2 class="text-[#FF0000] text-[22px] font-black hover:underline">
        <a
          href="https://en.wikipedia.org/wiki/Regularity_rally"
          target="_blank"
        >
          What Is a Time Speed Distance Rally?
        </a>
      </h2>
      <h2>
        TSD (Time/Speed/Distance) rallying, also known as regularity rallying,
        is a safe, enjoyable but exacting
        motor sport that fully puts to the test your car&apos;s reliability and
        responsiveness, a driver&apos;s ability and a navigator&apos;s accuracy
        in interpreting specific route instructions. A rally is a competition in
        which cars individually leave a starting point at a carefully recorded
        time, and are instructed to accurately follow a designated route while
        maintaining specific various rates of speed along this route.
      </h2>
      <h2 class="text-white">DISTANCE = TIME X SPEED</h2>
      <h2 class="text-white">TIME = DISTANCE/SPEED</h2>
      <h2 class="text-white">SPEED = DISTANCE/TIME</h2>
      <h2 class="text-[22px]">
        How to Add Time Speed Distance Function to a Roadbook
      </h2>
      <h2>
        Prescribed Speeds are added to the starting Waypoint and again in
        subsequent waypoints when Speed Changes are requred by Drag and Dropping
        a Speed Icon (Speed Tab) into the Waypoint
      </h2>
      <h2>
        User can display Target Times in any Waypoint by Drag and Dropping TSD
        TIME Icon into any Waypoint. This can be used to create helpful practice
        Roadbooks (Example: First Stage of a TSD Rally) or to offer participants
        a hint of correct time along the way.
      </h2>
      <h2>
        Choose Roadbook &gt; Decimal Format &gt; 0,000 in Road Rally format and
        distances print to three decimals (.000). The TSD worksheet uses the
        same precision, so crews can hold precise average speeds.
      </h2>
      <h2>
        Time controls take target times as hours and minutes (h:mm), and each
        one prints its own number (TC1A, TC1B&#8230;). Running a US event? Turn
        on Roadbook &gt; Show Alternate Distance Units for km and miles side by
        side.
      </h2>
    </div>
    <div class="py-8 flex flex-col gap-4">
      <h2 class="font-semibold">Ready to Print PDF Rally Roadbooks</h2>
      <picture class="contents">
        <source srcset="/images/time-speed-distance/TSD-CC-Roadbook-qbqkj0exbp7zn715rcf8vwohvur3q5tswwtesgk862.webp" type="image/webp" />
        <img width="450" height="457"
        decoding="async"
        src="/images/time-speed-distance/TSD-CC-Roadbook-qbqkj0exbp7zn715rcf8vwohvur3q5tswwtesgk862.png"
        title="TSD CC Roadbook"
        alt="TSD CC Roadbook"
        loading="lazy"
        class="flex m-auto"
        />
      </picture>
    </div>
    <div class="py-8 flex flex-col gap-4 text-left" @click="onSampleClick">
      <h2 class="font-semibold text-center">
        Rally Navigator File Export and PDF Print Sample Files
      </h2>
      <SampleRoadbookIntro
        name="Time Speed Distance"
        stats="48 km · 26 waypoints · 7-page A5 roadbook"
        description="An enduro TSD route near the Nevada Test and Training Range, with time controls, speed changes and running distances laid out for regularity timing."
        image="tsd-roadbook-page"
        :image-width="638"
        :image-height="872"
        pdf-href="/time-speed-distance/RN2-Time-Speed-Distance-How-It-Works-A5.pdf"
        rn2-href="/time-speed-distance/RN2%20Time%20Speed%20Distance%20How%20It%20Works.rn2"
      />
      <h2 class="font-bold text-left text-[17px]">
        RN2 File &#8211; Time Speed Distance Sample Route
      </h2>
      <ul class="list-disc pl-6 font-arial text-[14px] font-bold">
        <li>
          <p class="text-[#FF0000] hover:underline">
            <a
              href="time-speed-distance/RN2 Time Speed Distance How It Works.rn2"
              download="RN2 Time Speed Distance How It Works.rn2"
              target="_blank"
            >
              TSD Cross Country Rally Sample
            </a>
          </p>
        </li>
        <li>
          <p class="text-[#FF0000] hover:underline">
            <a
              href="time-speed-distance/RN2 Time Speed Distance How It Works Road Rally.rn2"
              download="RN2 Time Speed Distance How It Works Road Rally.rn2"
              target="_blank"
            >
              TSD Road Rally Sample
            </a>
          </p>
        </li>
      </ul>
      <h2 class="font-bold text-left text-[17px]">
        GPX and KML File &#8211; Time Speed Distance Sample Route
      </h2>
      <ul class="list-disc pl-6 font-arial text-[14px] font-bold">
        <li>
          <p class="text-[#FF0000] hover:underline">
            <a
              href="time-speed-distance/RN2 Time Speed Distance How It Works.gpx"
              target="_blank"
            >
              GPX TSD Rally Sample &#8211; Including OpenRally Scoring and
              Control Data
            </a>
          </p>
        </li>
        <li>
          <p class="text-[#FF0000] hover:underline">
            <a
              href="time-speed-distance/RN2 Time Speed Distance How It Works.kml"
              target="_blank"
            >
              KML TSD Rally Sample
            </a>
          </p>
        </li>
      </ul>
      <h2 class="font-bold text-left text-[17px]">
        PDF File &#8211; Time Speed Distance &#8211; Cross Country Rally
        Roadbook
      </h2>
      <ul class="list-disc pl-6 font-arial text-[14px] font-bold">
        <li>
          <p class="text-[#FF0000] hover:underline">
            <a
              href="time-speed-distance/RN2-Time-Speed-Distance-How-It-Works-A4.pdf"
              target="_blank"
            >
              A4 &#8211; TSD Cross Country Rally
            </a>
          </p>
        </li>
        <li>
          <p class="text-[#FF0000] hover:underline">
            <a
              href="time-speed-distance/RN2-Time-Speed-Distance-How-It-Works-A5.pdf"
              target="_blank"
            >
              A5 &#8211; TSD Cross Country Rally
            </a>
          </p>
        </li>
        <li>
          <p class="text-[#FF0000] hover:underline">
            <a
              href="time-speed-distance/RN2-Time-Speed-Distance-How-It-Works-Letter.pdf"
              target="_blank"
            >
              Letter &#8211; TSD Cross Country Rally
            </a>
          </p>
        </li>
        <li>
          <p class="text-[#FF0000] hover:underline">
            <a
              href="time-speed-distance/RN2-Time-Speed-Distance-How-It-Works-Legal.pdf"
              target="_blank"
            >
              Legal &#8211; TSD Cross Country Rally
            </a>
          </p>
        </li>
      </ul>
      <h2 class="font-bold text-left text-[17px]">
        PDF File &#8211; Time Speed Distance &#8211; Road Rally Roadbook
      </h2>
      <ul class="list-disc pl-6 font-arial text-[14px] font-bold">
        <li>
          <p class="text-[#FF0000] hover:underline">
            <a
              href="time-speed-distance/RN2-Time-Speed-Distance-How-It-Works-Road-Rally-A4-2.pdf"
              target="_blank"
            >
              A4 &#8211; TSD Road Rally
            </a>
          </p>
        </li>
        <li>
          <p class="text-[#FF0000] hover:underline">
            <a
              href="time-speed-distance/RN2-Time-Speed-Distance-How-It-Works-Road-Rally-A5.pdf"
              target="_blank"
            >
              A5 &#8211; TSD Road Rally
            </a>
          </p>
        </li>
        <li>
          <p class="text-[#FF0000] hover:underline">
            <a
              href="time-speed-distance/RN2-Time-Speed-Distance-How-It-Works-Road-Rally-Letter.pdf"
              target="_blank"
            >
              Letter &#8211; TSD Road Rally
            </a>
          </p>
        </li>
        <li>
          <p class="text-[#FF0000] hover:underline">
            <a
              href="time-speed-distance/RN2-Time-Speed-Distance-How-It-Works-Road-Rally-Legal.pdf"
              target="_blank"
            >
              Legal &#8211; TSD Road Rally Rally
            </a>
          </p>
        </li>
      </ul>
    </div>
    <div class="py-8 flex flex-col gap-4">
      <h2 class="font-semibold">Time Speed Distance Excel Worksheets</h2>
      <p class="font-arial text-[17px] font-semibold">
        Excel download file is completely editable. You can customize it for
        your event.
      </p>
      <p class="font-arial text-[17px] font-semibold">
        Automatically Downloads LAT/LON, Segment Distance, Total Distance,
        Target Speed, Segment Time and Total Time to Waypoint
      </p>
      <p class="font-arial text-[17px] font-semibold">
        Distances match your roadbook&#8217;s decimal format, up to three
        decimals (.000).
      </p>
      <picture class="contents">
        <source srcset="/images/time-speed-distance/TSD-Excel-Screen-Shot.webp" type="image/webp" />
        <img
        decoding="async"
        width="1205"
        height="1025"
        src="/images/time-speed-distance/TSD-Excel-Screen-Shot.png"
        class="flex m-auto"
        alt="Time Speed Distance Excel worksheet for rally timing"
        />
      </picture>
    </div>
    <div class="py-8 flex flex-col gap-4">
      <h2 class="font-semibold">Start Line and Time Control Worksheet</h2>
      <h2 class="font-black text-[#FF0000]">
        <a
          href="time-speed-distance/Time-Control-Worksheet.pdf"
          target="_blank"
        >
          Download PDF Sample Start Line and Time Control Worksheet
        </a>
      </h2>
      <p class="font-arial text-[17px] font-semibold">
        Excel download file is completely editable. You can customize it for
        your event.
      </p>
      <p class="font-arial text-[17px] font-semibold">
        Time Control Workers Manually Record Exact Arrival Time of Cars at Each
        Time Control
      </p>
      <picture class="contents">
        <source srcset="/images/time-speed-distance/TSD-Excel-Time-Control-Worksheet.webp" type="image/webp" />
        <img
        decoding="async"
        loading="lazy"
        width="1351"
        height="1025"
        src="/images/time-speed-distance/TSD-Excel-Time-Control-Worksheet.png"
        class="flex m-auto"
        alt="TSD rally start line and time control worksheet in Excel"
        />
      </picture>
    </div>
    <div class="py-8 flex flex-col gap-4">
      <h2 class="font-semibold">Time Control Scoring Calculation Worksheet</h2>
      <p class="font-arial text-[17px] font-semibold">
        Enter Stage Name, Roadbook Name, Starting Time and Interval, Car Number,
        Create Time Variation and Points Scoring
      </p>
      <p class="font-arial text-[17px] font-semibold">
        Then, Duplicate this Sheet in Excel for the EACH Time Control
      </p>
      <p class="font-arial text-[17px] font-semibold">
        In EACH Excel Sheet, Enter Waypoint # of Time Control, Time Control #,
        Time of Day at Time Control Arrival
      </p>
      <p class="font-arial text-[17px] font-semibold">
        Points are Automatically Calculated
      </p>
      <picture class="contents">
        <source srcset="/images/time-speed-distance/TSD-Excel-Time-Control-Calculation-Worksheet.webp" type="image/webp" />
        <img
        decoding="async"
        loading="lazy"
        width="1155"
        height="1001"
        src="/images/time-speed-distance/TSD-Excel-Time-Control-Calculation-Worksheet.png"
        class="flex m-auto"
        alt="TSD rally time control scoring calculation worksheet in Excel"
        />
      </picture>
    </div>
    <div class="py-8 flex flex-col gap-4">
      <h2 class="font-semibold">
        GPX Route File - Ready to Load in GPS Software
      </h2>
      <picture class="contents">
        <source srcset="/images/time-speed-distance/TSD-GPX-Screen-Shot.webp" type="image/webp" />
        <img
          decoding="async"
          loading="lazy"
          width="1919"
          height="1031"
          src="/images/time-speed-distance/TSD-GPX-Screen-Shot.png"
          class="flex m-auto"
          alt="TSD rally GPX route file ready to load in GPS software"
        />
      </picture>
    </div>
    <div class="py-8 flex flex-col gap-4">
      <h2 class="font-black">Useful Time Speed Distance Downloads</h2>
      <h2 class="font-black text-[#FF0000] hover:underline">
        <a
          href="time-speed-distance/2019_Introduction_to_TSD_Rallying.pdf"
          target="_blank"
        >
          SCCA Introduction to TSD Rallying
        </a>
      </h2>

      <h2 class="font-black text-[#FF0000] hover:underline">
        <a
          href="https://www.rebellerally.com/rebelle-enduro-challenges/"
          target="_blank"
        >
          Rebelle Rally &#8211; Rebelle Enduro Challenge
        </a>
      </h2>

      <h2 class="font-black text-[#FF0000] hover:underline">
        <a href="time-speed-distance/2013_TSD_Rally_Basics.pdf" target="_blank">
          Porsche Club of America TSD Info
        </a>
      </h2>
      <h2 class="font-black text-[#FF0000] hover:underline">
        <a
          href="time-speed-distance/TSD-Structure-and-Standards.pdf"
          target="_blank"
        >
          BMW Club TSD Info
        </a>
      </h2>
    </div>
    <GuideDownloadCta />
  </section>
  <section class="my-8 mx-auto max-w-[1400px]">
    <FeaturesBanner />
    <PartnersSmall />
    <RallyLogoDownload />
    <div class="py-8 mt-8 border-t border-white/50">
      <p class="text-[17px] md:text-[20px]">
        <strong class="text-white">Producing road books for paid events?</strong> A Pro Rally licence covers commercial use, and adds track distance, CAP headings and elevation data to your roadbook.
        <router-link to="/pro-features" class="text-[#FF0000] hover:underline"
          >See every Pro Rally feature &rarr;</router-link
        >
      </p>
    </div>
  </section>
  <RelatedGuides
    :links="[
        { to: '/how-to-create-a-road-rally', text: 'How to Create a Road Rally Roadbook' },
        { to: '/how-to-create-a-cross-country', text: 'How to Create a Cross Country Roadbook' },
        { to: '/fia-roadbook-specs-rules', text: 'FIA Road Rally Roadbook Specs' },
        { to: '/rally-roadbook', text: 'What Is a Rally Roadbook?' },
      ]"
  />
</template>

<script>
import YouTubeEmbed from './YouTubeEmbed.vue';
import FeaturesBanner from './FeaturesBanner.vue';
import RelatedGuides from './RelatedGuides.vue';
import GuideDownloadCta from './GuideDownloadCta.vue';
import SampleRoadbookIntro from './SampleRoadbookIntro.vue';
import { trackSampleDownload } from '../analytics';
import EventsBanner from './EventsBanner.vue';
import PartnersSmall from './PartnersSmall.vue';
import RallyLogoDownload from './RallyLogoDownload.vue';

export default {
  name: 'TimeSpeedDistance',
  components: {
    YouTubeEmbed,
    GuideDownloadCta,
    SampleRoadbookIntro,
    FeaturesBanner,
    RelatedGuides,
    RallyLogoDownload,
    PartnersSmall,
    EventsBanner,
  },
  data() {
    return {
      eventsBannerImages: [],
    };
  },
  mounted() {
    fetch('/BannerImagesLists/TSDBannerImageList.json')
      .then((response) => response.json())
      .then((data) => {
        this.eventsBannerImages = data.sort(() => Math.random() - 0.5);
      });
  },
  methods: {
    onSampleClick(event) {
      trackSampleDownload(event);
    },
  },
};
</script>

<style scoped></style>
